import dayjs from 'dayjs'
import { FILTER_TYPES } from '../../../hooks/table/useColumnFilters'
import { CustomColumnFiltersState } from '../../../pages/Workspace/components/interfaces.table'

interface QueryFilter {
	by: string
	type: number
	value: string | number
}

const DEFAULT_DATE = '0001-01-01'

export const mapColumnFiltersToQuery = (
	filters: CustomColumnFiltersState
): QueryFilter[] => {
	return filters.map(({ id, type, value }) => {
		let finalValue: string | number

		switch (true) {
			case type === FILTER_TYPES.BETWEEN && isRangeValue(value): {
				const start = value.startValue || ''
				const end = value.endValue || ''
				finalValue = `${start},${end}`
				break
			}

			case (id === 'createdAt' || id === 'modifiedAt') && !isRangeValue(value):
				finalValue = value ? dayjs(value).format('YYYY-MM-DD') : DEFAULT_DATE
				break

			case id === 'size':
				finalValue = Number(value) || 0
				break

			default:
				finalValue = String(value ?? '')
		}

		return {
			by: id,
			type,
			value: finalValue,
		}
	})
}

function isRangeValue(
	value: unknown
): value is { startValue?: string; endValue?: string } {
	return typeof value === 'object' && value !== null && 'startValue' in value
}
